import React, { memo } from 'react';

interface SectionProgressData {
  id: string;
  color: string;
}

interface ProgressIndicatorProps {
  title: string;
  sections: SectionProgressData[];
  activeSectionGlobal: number;
  startSectionGlobalIndex: number;
  endSectionGlobalIndex: number;
  visibilityAndTrackingStartIndex: number;
  progressMode?: 'perSection' | 'overall';
  overallProgress?: number;
  isActive?: boolean;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  title,
  sections,
  activeSectionGlobal,
  startSectionGlobalIndex,
  endSectionGlobalIndex,
  visibilityAndTrackingStartIndex,
  progressMode = 'perSection',
  overallProgress = 0,
  isActive = true,
}) => {
  if (activeSectionGlobal < visibilityAndTrackingStartIndex) {
    return null;
  }

  return (
    <div className="progress-indicator-wrapper" style={{ opacity: isActive ? 1 : 0 }}>
      <div className="progress-indicator-title">{title}</div>
      <div className="progress-pills-container">
        {sections.map((section, index) => {
          let isFilled = false;
          if (progressMode === 'perSection') {
            const currentPillGlobalSectionIndex = startSectionGlobalIndex + index;
            if (activeSectionGlobal > endSectionGlobalIndex) {
              isFilled = true;
            } else {
              isFilled = activeSectionGlobal >= currentPillGlobalSectionIndex;
            }
          } else if (progressMode === 'overall') {
            const clampedOverallProgress = Math.max(0, Math.min(1, overallProgress));
            const filledCount = Math.floor(clampedOverallProgress * sections.length);
            isFilled = index < filledCount;
            if (clampedOverallProgress >= 0.99) {
              isFilled = true;
            }
          }

          const pillStyle: React.CSSProperties = {
            borderColor: section.color,
            backgroundColor: isFilled ? section.color : '#FFFFFF',
          };

          return (
            <div
              key={section.id || `pill-${index}`}
              className="progress-pill"
              style={pillStyle}
            />
          );
        })}
      </div>
    </div>
  );
};

export default memo(ProgressIndicator);
